import React from 'react';
import AuthProvider from 'contexts/AuthProvider';

const withAuth = (InputComponent: React.FC) => {
  const EnhancedComponent: React.FC = () => {
    return (
      <AuthProvider>
        <InputComponent />
      </AuthProvider>
    );
  };

  return EnhancedComponent;
};

export default withAuth;
